import { render, staticRenderFns } from "./guideline_consensus.vue?vue&type=template&id=22373648&"
import script from "./guideline_consensus.vue?vue&type=script&lang=js&"
export * from "./guideline_consensus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports